export const soapPastRootSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  bgcolor: '#FFFFFF',
  overflow: 'hidden'
};

export const soapPastHeaderSx = {
  height: 40,
  minHeight: 40,
  px: 1.75,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  bgcolor: '#FFFFFF',
  borderBottom: '1px solid #D9D9D9'
};

export const soapPastTitleSx = {
  fontSize: 14,
  fontWeight: 500,
  color: '#424242'
};

export const expandButtonSx = {
  p: 0.25,
  color: '#424242',

  '&:hover': {
    bgcolor: 'transparent',
    color: '#1976D2'
  }
};

export const expandIconSx = {
  fontSize: 18
};

export const tableContainerSx = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',

  '&::-webkit-scrollbar': {
    width: 6
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: '#F5F5F5'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C5C5C5',
    borderRadius: 10
  }
};

export const tableSx = {
  width: '100%',
  tableLayout: 'fixed'
};

export const headCellSx = {
  height: 40,
  padding: '0 18px',
  fontSize: 12,
  fontWeight: 500,
  color: '#424242',
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
};

export const dateHeadCellSx = {
  ...headCellSx,
  width: '20%'
};

export const subjectiveHeadCellSx = {
  ...headCellSx,
  width: '50%'
};

export const statusHeadCellSx = {
  ...headCellSx,
  width: '30%'
};

export const bodyCellSx = {
  height: 40,
  padding: '0 18px',
  fontSize: 12,
  color: '#424242',
  borderBottom: '1px solid #EEEEEE'
};

export const ellipsisCellSx = {
  ...bodyCellSx,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};

export const rowSx = {
  bgcolor: '#FFFFFF',
  cursor: 'pointer',

  '&:hover .MuiTableCell-root': {
    bgcolor: '#FCF8F2 !important'
  },

  '&.MuiTableRow-hover:hover .MuiTableCell-root': {
    bgcolor: '#FCF8F2 !important'
  },

  '&:last-of-type .MuiTableCell-root': {
    borderBottom: 0
  }
};

export const linkSx = {
  p: 0,
  maxWidth: '100%',
  display: 'inline-block',
  color: '#1976D2',
  fontSize: 12,
  fontWeight: 400,
  cursor: 'pointer',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  textDecoration: 'underline',
  verticalAlign: 'middle',

  '&:hover': {
    color: '#125A9C',
    textDecoration: 'underline'
  }
};

export const emptyCellSx = {
  py: 3,
  textAlign: 'center',
  fontSize: 12,
  color: '#757575',
  borderBottom: 0
};